import React, { useState } from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import TopBar from "./TopBar";
import logo from "../../assets/img/mtLogo.png";

// Redesigned header. Mobile menu is plain React state, so it no longer depends on
// the template's main.js helpers (toggleScrolled, mobileNavToogle, etc.).
// Keep your aosInit()/initGLightbox() calls elsewhere if other pages still use them.
const Header = () => {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <>
      <TopBar />
      <header className="vd-header">
        <div className="container vd-header__inner">
          {/* <Logo /> */}
          <img src={logo} alt="Vedum" className="img-fluid vd-header__logo" />
          <nav aria-label="Main" className={`vd-nav ${open ? "is-open" : ""}`}>
            <a href="/#platform" onClick={close}>
              Platform
            </a>
            <a href="/#insights" onClick={close}>
              Legal Insights
            </a>
            <a href="/#impact" onClick={close}>
              Impact
            </a>
            <a href="/#landscape" onClick={close}>
              Why now
            </a>
            <a href="/#security" onClick={close}>
              Security
            </a>
            <Link to="/solutions-tax" onClick={close}>
              Solutions
            </Link>
          </nav>

          <div className="vd-header__cta">
            <a
              className="vd-link-btn"
              href="https://portal.vedum.ai/"
              target="_blank"
              rel="noreferrer"
            >
              Log in
            </a>
            <a className="vd-btn vd-btn--primary vd-btn--sm" href="/#contact">
              Book a demo
            </a>
            <button
              className="vd-burger"
              aria-label="Toggle menu"
              aria-expanded={open}
              onClick={() => setOpen(!open)}
            >
              <i className={`bi ${open ? "bi-x" : "bi-list"}`} />
            </button>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
